export const TUNE = {
    DELAY_SIB: 30,       // sibling 확정 지연(ms) — 빠르게
    DELAY_INSIDE: 90,    // inside 확정 지연(ms)
    PAD: 4,              // 행의 최상/최하 보호 패딩(px)
    DEAD_L1: 6,          // 1뎁스 데드존(px)
    DEAD_N: 4,           // 하위뎁스 데드존(px)
    BAND_L1: [0.33, 0.67], // 1뎁스 inside 밴드(비율)
    BAND_N: [0.38, 0.62],  // 하위뎁스 inside 밴드(비율)
    GAP_MAX: 44,         // 확정시 벌어질 높이(px)
    GAP_LERP: 0.40,      // 갭 보간 속도(0~1, 높을수록 빠름)
    PENDING_GAP: 10      // 확정 전(대기중) 미리보기 갭(px)
};
export const MENU_TYPE_SELECT = [
    {label: "폴더", value: "FOLDER"},
    {label: "작성", value: "FORM"},
    // {label: "HTML", value: "PAGE"},
    {label: "게시판", value: "BOARD"},
    {label: "템플릿", value: "TEMPLATE"},
    // {label: "e-뉴스", value: "E-NEWS"},
];
export const FILE_COUNT_LIST = [
    {label: "1개", value: 1},
    {label: "2개", value: 2},
    {label: "3개", value: 3},
    {label: "4개", value: 4},
    {label: "5개", value: 5},
]
export const FILE_SIZE_LIST = [
    {label: "3MB", value: "3MB"},
    {label: "4MB", value: "4MB"},
    {label: "5MB", value: "5MB"},
    {label: "6MB", value: "6MB"},
    {label: "7MB", value: "7MB"},
    {label: "8MB", value: "8MB"},
    {label: "9MB", value: "9MB"},
    {label: "10MB", value: "10MB"},
];

export const BOARD_SUB_TYPE_LIST = [
    {label: "리스트형", value: "LIST"},
    {label: "갤러리형", value: "GALLERY"},
    {label: "블로그형", value: "BLOG"},
    // {label: "FORM", value: "FORM"},
    {label: "파트너형", value: "PARTNER"},
    {label: "협력사형", value: "COOPERATION"},
]
export const FORM_SUB_TYPE_LIST = [
    {label: "문의하기", value: "CONTACT"},
    {label: "신청하기", value: "APPLY"},
]
export const INIT_SUB_TYPE = "LIST";
export const INIT_FORM_SUB_TYPE = "CONTACT";
export const INIT_FORM_OPTION = {
    isActive: true,
    file: {count: 1, size: "3MB"},
    floatMenu: null,
}
export const INIT_BOARD_OPTION = {
    isActive: true,
    limit: 10,
    paging: 10,
    file: {count: 1, size: "3MB"},
    headSubTitle: "",
}
export const INIT_PAGE_OPTION = {
    isActive: true,
    seo: {
        title: "",
        description: "",
        keyword: "",
    }
}
export const INIT_TEMPLATE_OPTION = {
    isActive: true,
    headSubTitle: "",
}
export const INIT_FORM_CONTENT = [
    {_id: "0", type: "select", used: true, name: "문의유형", rawOptions: "", options: [], selected: null, required: true },
    {_id: "1", type: "text", used: false, name: "기업/학교명", required: false },
    {_id: "2", type: "tel", used: true, name: "연락처", required: true },
    {_id: "3", type: "email", used: true, name: "이메일 주소", required: true },
    {_id: "4", type: "files", used: true, name: "파일 업로드", required: false },
    {
        _id: "5",
        type: "content",
        used: true,
        name: "내용",
        value: `[제품 문의]\n1.문의하는 제품의 회사명 및 Cat No.(품번)\n2.참고할 수 있는 정보가 있다면, 첨부파일로 전달 부탁드립니다.\n\n[견적 문의]\n* 주문/견적 요청하는 제품의 회사명 및 Cat No.(품번)\n\n분석서비스 문의/실험실 대여 문의/ Custom문의\n*별도 내용 기재 없음\nBulk 문의\n 1.문의하는 제품의 회사명 및 Cat No.(품번)\n\n2.필요한 용량\n\n3.사용 용도 (ex. Binding assay, in vivo injection, cell culture 등)\n현재 문의하시는 제품의 소용량 제품을 사용중이신가요?\n\n샘플 문의\n*신청하는 제품의 회사명 및 Cat No.(품번)"`
        , required: true
    },
    {
        _id: "6",
        type: "agree",
        used: true,
        name: "개인정보",
        value: `개인정보에 대한 안내 정보를 작성해 주세요.`
        , required: true
    },
];